import React, { useContext } from "react";
import { AuthContext } from "../../../../context/AuthContext";

type ResultType = {
  heading: string;
  text: string;
  cards: CardProps[];
  cardColor: string;
};

type CardProps = {
  icon: string;
  subheading: string;
  text: string;
};

const Result = ({ heading, text, cards, cardColor }: ResultType) => {
  const dataContext = useContext(AuthContext)

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div className={theme === 'dark' ? "bg-white transition-all duration-500" : "bg-black text-white transition-all duration-500"}>
      <div className="max-w-screen-2xl mx-auto px-5 lg:px-20 py-8 lg:py-20">
        <div>
          <h1 className="font-montserrat font-bold text-3xl mb-2">{heading}</h1>
          <p className="mb-4 lg:mb-9">{text}</p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-8">
            {cards.map((item, index) => (
              <div
                className={`${theme === 'dark' ? `${cardColor}` : "bg-[#141414]"} py-14 px-10 rounded-2xl transition-all duration-500`}
                key={index}
              >
                <div className="flex flex-col justify-between items-center gap-10">
                  <img src={item.icon} className="" alt="" />
                  <h3 className="font-gtAmerica font-2xl text-white font-semibold">
                    {item.subheading}
                  </h3>
                  <p className="font-montserrat text-white text-center">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Result;
